module.exports = __webpack_public_path__ + "img/pill-dimensions-special.b138afeb.svg";